// extracted by mini-css-extract-plugin
export var activeFilterButton = "_lu-c";
export var backButton = "_lu-4";
export var backIcon = "_lu-5";
export var chevronShortcut = "_lu-6";
export var container = "_lu-1";
export var editor = "_lu-8";
export var editorWrapper = "_lu-7";
export var prefix = "_lu-2";
export var searchIcon = "_lu-3";
export var suffix = "_lu-9";
export var suffixContent = "_lu-a";
export var suffixText = "_lu-b";
export var wrapper = "_lu-0";